import Modal from "react-modal";
import { USER_TYPES_CATEGORIES } from "../../../../constants/globals";

const PackageModal = ({
  isOpen,
  onClose,
  packageIcon,
  packageDetails,
  setIsPackageOpen,
  clientCategory,
}) => {
  const isClientMarkter =
    clientCategory == USER_TYPES_CATEGORIES.SERVICE_MARKETING;
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Accept Request Modal"
      className={
        "tw-flex tw-items-center tw-justify-center tw-fixed tw-inset-0"
      }
      overlayClassName="tw-fixed tw-inset-0 tw-bg-black/50 tw-flex tw-items-center tw-justify-center"
    >
      <div className="tw-relative tw-w-full md:tw-w-auto shadow-lg bg-white border tw-rounded-xl">
        <div className="tw-flex tw-relative !tw-justify-center">
          <img
            src={packageIcon}
            alt="PackageCategory"
            className="tw-w-10 tw-inline-block tw-mx-1 tw-mt-1"
          ></img>
        </div>
        <h2 className="tw-text-center tw-py-2 tw-mt-1 tw-font-bold">
          {packageDetails?.package_name_en}
        </h2>
        <span
          onClick={onClose}
          className="material-icons tw-cursor-pointer tw-absolute -tw-top-6 tw-text-[30px] -tw-right-8 tw-text-red-500"
        >
          cancel
        </span>
        <div className="tw-max-h-[62vh] tw-overflow-y-auto custom-scrollbar tw-p-3 tw-m-1 md:tw-p-5 md:tw-m-5  md:tw-mt-0 tw-pt-0 md:tw-border md:tw-border-black tw-rounded-lg md:tw-shadow-md">
          <div className="tw-text-[#5A5959] tw-text-md tw-text-center tw-pb-5 tw-flex tw-justify-center tw-items-center">
            <span>{packageDetails?.total_price} E.M</span>
            {isClientMarkter && (
              <>
                <span className="tw-px-2 tw-text-3xl">/</span>
                <span>{packageDetails?.total_package_pv} PV</span>
              </>
            )}
          </div>

          <div className="tw-text-black tw-font-semibold">
            {/* Heading */}
            {isClientMarkter && (
              <div>
                <div className="tw-grid tw-grid-cols-2 tw-justify-between tw-mb-3">
                  <div>Registeration Fees</div>
                  <div className="tw-text-end">
                    {packageDetails?.registration_price} E.M
                  </div>
                </div>
              </div>
            )}
            <div>
              <div className="tw-grid tw-grid-cols-2 tw-justify-between tw-text-[#023441] tw-font-bold tw-mb-3">
                <div>Courses</div>
                <div className="tw-text-end">E-Money</div>
              </div>
            </div>

            {/* Heading */}
            {packageDetails?.courses?.map((course, index) => (
              <div key={index}>
                <div className="tw-grid tw-grid-cols-2 tw-justify-between tw-items-center tw-font-bold">
                  <div>
                    <img
                      src={course.image}
                      alt={course.course_name_en}
                      width="50px"
                      className="tw-inline-block tw-me-2"
                    ></img>
                    <span className="tw-inline-block">
                      {course.course_name_en}
                    </span>
                  </div>
                  <div className="tw-text-end">{course.e_money}</div>
                </div>
              </div>
            ))}

            <span className="tw-w-full tw-h-[2px] tw-inline-block tw-bg-slate-400"></span>
            {/* Total */}
            {packageDetails?.price_after_voucher === 0 ||
            !packageDetails?.price_after_voucher ? (
              <div>
                <div className="tw-grid tw-grid-cols-2 tw-justify-between">
                  <div>Total Price:</div>
                  <div className="tw-text-end">
                    {packageDetails?.total_price} E.M
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div>
                  <div className="tw-grid tw-grid-cols-2 tw-justify-between tw-text-sm tw-text-gray-400">
                    <div>Original Price:</div>
                    <div className="tw-text-end tw-line-through">
                      {packageDetails?.total_price} E.M
                    </div>
                  </div>
                </div>
                <div>
                  <div className="tw-grid tw-grid-cols-2 tw-justify-between tw-items-center tw-text-[16px]">
                    <div>Total Price After Voucher :</div>
                    <div className="tw-text-end">
                      {packageDetails?.price_after_voucher} E.M
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="tw-grid">
          <button
            onClick={() => {
              document
                .getElementById(`package-${packageDetails?.id || ""}`)
                ?.click();
              setIsPackageOpen(false);
            }}
            className={`tw-bg-primary
                 !tw-rounded-lg tw-text-white !tw-px-10 tw-py-1 !tw-mt-1 !tw-mb-3 !tw-mx-auto `}
          >
            Confirm
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PackageModal;
